const FO = {
  ibanLength: 18,
};
export { FO };
